import {langSwitch} from "../../../../core/utils/lang";
import React, {memo} from "react";
import {useSelector} from "react-redux";


const PreselectionDesc = () => {
  const langData = useSelector(state => state.theme.langData);

  return (
    <>
      <h2>{langSwitch("preselection", "title", langData.lang)}</h2>
      <p dangerouslySetInnerHTML={{__html: langSwitch("preselection", "subtitle", langData.lang).replace(/\n/, "<br />")}}/>
    </>
  )
}
export default memo(PreselectionDesc);
